import { useQuery } from "@tanstack/react-query";

interface UseImageLoadOptions {
  enabled?: boolean;
  retryCount?: number;
}

const loadImage = (src: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = () => {
      resolve(src);
    };

    img.onerror = () => {
      reject(new Error(`Failed to load image: ${src}`));
    };

    // WebP 변환 시도
    const webpSrc = src.replace(/\.(jpg|png|avif)$/, ".webp");
    const webpImg = new Image();

    webpImg.onload = () => {
      resolve(webpSrc);
    };

    webpImg.onerror = () => {
      // WebP 실패 시 원본 이미지 사용
      img.src = src;
    };

    webpImg.src = webpSrc;
  });
};

export const useImageLoad = (
  imageUrl: string | undefined,
  options: UseImageLoadOptions = {},
) => {
  const { enabled = true, retryCount = 3 } = options;

  return useQuery({
    queryKey: ["image", imageUrl],
    queryFn: () => loadImage(imageUrl!),
    enabled: enabled && !!imageUrl,
    retry: retryCount,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    staleTime: Infinity, // 이미지는 한번 로드되면 캐시에서 계속 사용
    gcTime: 24 * 60 * 60 * 1000, // 24시간 캐시 유지
  });
};
